var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6664 22.917V27.0835H27.0835V41.6664H22.917V27.0835H8.33411V22.917H22.917V8.33412H27.0835V22.917H41.6664ZM42.6768 42.6768C32.9146 52.439 17.0859 52.439 7.32165 42.6768C-2.44055 32.9146 -2.44055 17.0859 7.32165 7.32165C17.0859 -2.44055 32.9125 -2.44055 42.6768 7.32165C52.4411 17.0859 52.4411 32.9146 42.6768 42.6768ZM39.731 10.2695C31.7271 2.26555 18.5505 1.98848 10.2695 10.2695C2.14681 18.3921 2.14681 31.6084 10.2695 39.7311C18.5505 48.012 31.7292 47.7329 39.731 39.7311C47.8537 31.6084 47.8537 18.3921 39.731 10.2695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b13da5e581dff767199da1792ea95fef.svg";
export { ForwardRef as ReactComponent };